import { render, staticRenderFns } from "./DeathOfPartners.vue?vue&type=template&id=8c688a6c&scoped=true&"
import script from "./DeathOfPartners.vue?vue&type=script&lang=js&"
export * from "./DeathOfPartners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c688a6c",
  null
  
)

export default component.exports